import MUIDivider, { DividerProps } from '@mui/material/Divider';

const Divider = (props: DividerProps) => {
  return <MUIDivider {...props} />;
};

export default Divider;
